/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { LabelSize } from 'components/atoms/ProductLabel';
import dayjs from 'dayjs';
import { DiscountType } from 'enums/discountType';
import { ProductApplicableType } from 'enums/productApplicableType';
import Thunder from 'images/icon/thunder.inline.svg';
import { DiscountLabelResource } from './api/swaggerApi/data-contracts';
import { Media } from './hook/useMedia';
import thousands from './thousands';

export const produceEventLabels = (
	media: Media,
	type: 'card' | 'page',
	discounts?: DiscountLabelResource[],
	eventPrice?: number,
) => {
	const filteredDiscounts = discounts
		?.filter(d => !d.isArchived)
		.filter(event => {
			const currentTime = dayjs();
			const startTime = dayjs(event.eventBeginAt);
			const endTime = dayjs(event.eventEndAt);

			return currentTime.isAfter(startTime) && currentTime.isBefore(endTime);
		})
		.filter(d => d.applicable !== ProductApplicableType.ALL_PRODUCTS)
		.sort((a, b) => b.id! - a.id!);

	const labels = [];
	if (eventPrice) {
		let size = 'large' as LabelSize;
		if (media === 'mobile') {
			if (type === 'card') {
				size = 'xs';
			}
			if (type === 'page') {
				size = 'smallInPage';
			}
		}
		labels.push({
			text: '限時下殺',
			backgroundColor: '#F27292',
			size,
			Icon: Thunder,
		});
	}
	if (!filteredDiscounts) return labels;

	filteredDiscounts.forEach((item, index) => {
		let size = 'small' as LabelSize;
		if (media === 'mobile') {
			if (type === 'card') {
				size = 'xxs';
			}
			if (type === 'page') {
				size = 'xsLight';
			}
		}
		let backgroundColor = '#8C7DBE';
		if (index % 2 === 1) {
			backgroundColor = '#70BF54';
		}
		const text =
			item.type === DiscountType.DISCOUNT_PRICE
				? `滿${thousands(item.X)}折${thousands(item.Y)}`
				: `滿${thousands(item.X)}打${thousands(item.Y)}折`;
		labels.push({ text, backgroundColor, size });
	});
	return labels.slice(0, 3);
};
